define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    var tmpl = require('tmpl');
    const i18n = require('i18n');
    const _ = require('underscore');
    const device = require('util/device.util');
    const BaseView = require('common/base.view');
    var Form = require('class/form.class');

    /**
     * @override - replacement for showErrorMessage in core, used for errors and success
     * @returns {Form}
     */
    Form.prototype.showErrorMessage = function(data = {}) {
        this.$el.find('.fn-form-messages').html(tmpl['common.messages']({
            className: data.className || 'error',
            content: data.errorMessage || i18n.tExt(data.translation, data.content) || 'System Error'
        }));

        return this;
    };

    /**
     * Delegate all change/validate events for inputs of current form
     * @return {Form}
     */
    Form.prototype.delegateEvents = function() {
        var isEventTriggeredOnFormField = function(e) {
            return Array.from(this.$elements).some(function(el) {
                var isInField = el.contains(e.target);

                if (isInField) {
                    var error = el.querySelector('.error-tooltip');

                    isInField = !error || !error.contains(e.target);
                }

                return isInField;
            });
        }.bind(this);
        var getFormControlFromEvent = function(e) {
            return Array.from(this.$elements).filter(function(el) {
                return el.contains(e.target);
            })[0];
        }.bind(this);

        this._setAutoFocus();

        // fix dropDown list after device rotation on SGT3
        $(window).on('resize.form', _.throttle(function() {
            if (!document.activeElement || !document.activeElement.tagName) {
                return;
            }

            var isSelect = document.activeElement.tagName.toLowerCase() === 'select';
            var isSGT3 = device.alias === 'galaxy_tab_3_10';
            var isChrome = device.browserName === 'chrome';

            if (isSelect && isSGT3 && isChrome) {
                document.activeElement.blur();
            }
        }, 500));

        // fix for iOS 10
        if (device.os === 'ios' && parseInt(device.osVersion) === 10) {
            this.$el.on('submit.form', BaseView.hideKeyboard);
        }

        this.$elements.find('select, input[type="checkbox"], input[type="radio"].segmented-radio')
            .on('change.form', function(e) {
                BaseView.redraw(e.target);
            });

        var tapEvent = 'tap.form' + this.options.id;
        var focusInEvent = 'focusin.form' + this.options.id;
        var validationEvent;

        $('body')
            .on(tapEvent + ' ' + focusInEvent, function(event) {
                var isSameField = false;
                var isFormFieldEvent = isEventTriggeredOnFormField(event);
                var $activeFormField = isFormFieldEvent
                    ? $(getFormControlFromEvent(event))
                    : null;
                var isEnabledFiled = !event.target.disabled;
                const { target: { type } } = event;

                if (event.target.readOnly && (type === 'radio' || type === 'checkbox')) {
                    event.preventDefault();

                    return;
                }

                if (isFormFieldEvent && event.type === 'focusin') {
                    $activeFormField.trigger('form:focusin.form');
                }
                // When plus and minus buttons are disabled, event.target is their parent element, so error message is getting removed.
                if ($activeFormField && isEnabledFiled && !event.target?.classList?.contains('field_name_amount')) { // @theme
                    this.resetField($activeFormField);
                }

                if (validationEvent) {
                    isSameField = $activeFormField && $activeFormField[0].contains(validationEvent.target);

                    if (!isSameField) {
                        this.validateField(getFormControlFromEvent(validationEvent), this.options.data, {
                            event: validationEvent
                        });
                    }
                    validationEvent = null;
                }
            }.bind(this))
            .on('focusout.form' + this.options.id, function(event) {
                if (isEventTriggeredOnFormField(event)) {
                    $(event.target).trigger('form:focusout.form');
                    validationEvent = event;
                }
            })
            .on('keydown.form' + this.options.id, function(event) {
                var { key, target } = event;
                var spaceKey = key === ' ' || key === 'Spacebar';

                if (spaceKey && target.className.includes(this.hightlightControlClass)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    var inputElement = target.querySelector('input') || {};
                    var { type, checked } = inputElement || {};

                    if (type !== 'radio' && type !== 'checkbox' || checked && type === 'radio') {
                        return;
                    }

                    inputElement.checked = !checked;
                    $(inputElement).trigger('change');
                }

                if (key === 'Enter' && target.className.includes('fn-toggle-password-visibility')) {
                    event.stopImmediatePropagation();

                    this.handleTogglePasswordVisibility(event);
                }
            }.bind(this))
            .on('mousedown.form' + this.options.id, (event) => {
                if (event.target.readOnly) {
                    event.preventDefault();
                }
            });

        var eventName = device.formFactor === 'desktop' ? 'mousedown.form' : 'touchstart.form';

        this.$el
            .on(eventName, '.fn-toggle-password-visibility', this.handleTogglePasswordVisibility.bind(this));

        return this;
    };

    module.exports = Form;
});
